export default function getFieldsFromQuery<
  T,
  K extends (keyof T)[],
  P,
  G extends Record<keyof T, (params: P) => T[keyof T]>,
>({ fields, params, getter }: { fields: [...K]; params: P; getter: G }): Pick<T, K[number]> {
  const ret: Partial<T> = {}

  fields.forEach(field => {
    ret[field] = getter[field](params)
  })

  return ret as Pick<T, K[number]>
}
